import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Main = () => import('./Index.vue');
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flow'),
      component: SettingsContent,
      props: {
        headerTitle: 'FLOW.HEADER',
        icon: 'automation',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'flow_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'flow_list',
          component: Main,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
